import axios from "axios";
const BASE_URL = process.env.REACT_APP_API_BASE_URL;

// Action types fetch
export const FETCH_BANNERS_REQUEST = "FETCH_BANNERS_REQUEST";
export const FETCH_BANNERS_SUCCESS = "FETCH_BANNERS_SUCCESS";
export const FETCH_BANNERS_FAILURE = "FETCH_BANNERS_FAILURE";

// Action types add 
export const ADD_BANNER_REQUEST = "ADD_BANNER_REQUEST";
export const ADD_BANNER_SUCCESS = "ADD_BANNER_SUCCESS";
export const ADD_BANNER_FAILURE = "ADD_BANNER_FAILURE";

// Action types for delete
export const DELETE_BANNER_REQUEST = "DELETE_BANNER_REQUEST";
export const DELETE_BANNER_SUCCESS = "DELETE_BANNER_SUCCESS";
export const DELETE_BANNER_FAILURE = "DELETE_BANNER_FAILURE";

// Action creators
export const fetchBannersRequest = () => ({
  type: FETCH_BANNERS_REQUEST,
});

export const fetchBannersSuccess = (banners) => ({
  type: FETCH_BANNERS_SUCCESS,
  payload: banners,
});

export const fetchBannersFailure = (error) => ({
  type: FETCH_BANNERS_FAILURE,
  payload: error,
});

// Action types add
export const addBannerRequest = () => ({
    type: ADD_BANNER_REQUEST,
  });
  
  export const addBannerSuccess = (banner) => ({
    type: ADD_BANNER_SUCCESS,
    payload: banner,
  });
  
  export const addBannerFailure = (error) => ({
    type: ADD_BANNER_FAILURE,
    payload: error,
  });

  // Action creators for delete
export const deleteBannerRequest = () => ({
    type: DELETE_BANNER_REQUEST,
  });
  
  export const deleteBannerSuccess = (bannerId) => ({
    type: DELETE_BANNER_SUCCESS,
    payload: bannerId,
  });
  
  export const deleteBannerFailure = (error) => ({
    type: DELETE_BANNER_FAILURE,
    payload: error,
  });

// Thunk action to fetch banners
export const fetchBanners = () => async (dispatch) => {
  dispatch(fetchBannersRequest());
  try {
    const response = await axios.get(`${BASE_URL}/v1/api/getAllBanners`);
    dispatch(fetchBannersSuccess(response.data.data));
  } catch (error) {
    dispatch(fetchBannersFailure(error.message));
  }
};


export const addBanner = (formData, bannerType) => async (dispatch) => {
    dispatch(addBannerRequest());
    try {
      let url = '';
      switch (bannerType) {
        case 'topBanners':
          url = `${BASE_URL}/v1/api/create/topBanner`;
          break;
        case 'midBanners':
          url = `${BASE_URL}/v1/api/create/midSlide`;
          break;
        case 'bottomBanners':
          url = `${BASE_URL}/v1/api/create/bottomSlide`;
          break;
        default:
          throw new Error('Invalid banner type');
      }
  
      const response = await axios.post(url, formData, {
        headers: {
          'Content-Type': 'multipart/form-data',
          authorization: `${localStorage.getItem('token')}`,
        },
      });
  
      dispatch(addBannerSuccess(response.data));
    } catch (error) {
      dispatch(addBannerFailure(error.message));
    }
  };
  
  



// // Thunk action to delete a banner

export const deleteBanner = (bannerId, bannerType) => async (dispatch) => {
    dispatch(deleteBannerRequest());
    try {
      const response = await axios.delete(`${BASE_URL}/v1/api/banner/delete/${bannerId}`, {
        headers: {
          authorization: `${localStorage.getItem('token')}`,
        },
      });
  
      // Check if the response indicates success
      if (response.data.meta.status) {
        dispatch(deleteBannerSuccess({ bannerId, bannerType })); // Successfully deleted, update UI optimistically
        dispatch(fetchBanners());  // Refetch banners to ensure the UI is in sync with the server
      } else {
        dispatch(deleteBannerFailure(response.data.meta.message));  // Handle the error message from the server
      }
    } catch (error) {
      dispatch(deleteBannerFailure(error.message));  // Handle unexpected errors
    }
  };
  